module.exports = require('./helpers/bundle-url').getBundleURL('hcTqB') + "mobileBackground.36acc886.svg";